var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Schema } from '../';

var API = "https://kompass.dimu.org/admin/api";

var ExampleSchema = function (_Component) {
    _inherits(ExampleSchema, _Component);

    function ExampleSchema() {
        var _temp, _this, _ret;

        _classCallCheck(this, ExampleSchema);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            formData: {},
            language: "no"
        }, _this.uploadFile = function (uploadUrl, file, data, onUpdate) {
            console.log('example:uploadFile', uploadUrl);

            var payload = new FormData();
            payload.append('file', file);

            var xhr = new XMLHttpRequest();
            xhr.upload.addEventListener("progress", function (event) {
                return _this.uploadProgress(event, data, onUpdate);
            }, false);
            xhr.addEventListener("load", function (event) {
                return _this.uploadProgress(event, data, onUpdate);
            }, false);
            //  xhr.addEventListener("error", uploadFailed, false);
            //  xhr.addEventListener("abort", uploadCanceled, false);
            xhr.open("POST", uploadUrl);
            xhr.send(payload);
        }, _this.uploadProgress = function (event, data, onUpdate) {
            var progress = void 0;

            if (event.lengthComputable) {
                progress = Math.round(event.loaded * 100 / event.total);
            } else {
                progress = 0;
            }

            console.log('example:uploadProgress', progress);

            onUpdate({
                mediaId: data.uniqueId,
                media: data,
                uploadProgress: progress
            });
        }, _this.receiveUploadUrl = function (file, data, onAdd, onUpdate) {
            console.log('example:receiveUploadUrl', data);

            var uniqueId = data.uniqueId,
                uploadUrl = data.uploadUrl;


            if (uniqueId && uploadUrl) {

                onAdd({
                    mediaId: data.uniqueId,
                    media: data
                });

                _this.uploadFile(uploadUrl, file, data, onUpdate);
            }
        }, _this.requestUploadUrl = function (file, onAdd, onUpdate) {
            console.log('example:requestUploadUrl', file);

            var type = file.type,
                name = file.name;


            var data = {
                title: name,
                content: {
                    title: name,
                    filename: name
                }
            };

            var payload = JSON.stringify(data);

            var url = API + '/media/upload';

            if (type.startsWith('image')) {
                url = url + '/image';
            } else if (type.startsWith('video')) {
                url = url + '/video';
            } else if (type.startsWith('audio')) {
                url = url + '/audio';
            } else {
                url = url + '/misc';
            }

            fetch(url, {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json; charset=utf-8"
                },
                body: payload
            }).then(function (response) {
                return response.json();
            }, function (error) {
                return console.log('An error occurred.', error);
            }).then(function (data) {
                return _this.receiveUploadUrl(file, data, onAdd, onUpdate);
            });
        }, _this.onUpload = function (upload) {
            console.log('example:onUpload', upload);

            var acceptedFiles = upload.acceptedFiles,
                onAdd = upload.onAdd,
                onUpdate = upload.onUpdate;


            acceptedFiles.forEach(function (file) {
                _this.requestUploadUrl(file, onAdd, onUpdate);
            });
        }, _this.onDialog = function (dialog) {
            console.log('example:onDialog', dialog);
        }, _this.onChange = function (newState) {
            console.log('example:onChange', newState);

            _this.setState(_extends({}, newState));
        }, _this.onSubmit = function (_ref) {
            var formData = _ref.formData,
                errors = _ref.errors;

            console.log('example:onSubmit', formData);

            _this.setState({
                formData: formData,
                errors: errors
            });
        }, _this.renderErrors = function () {
            var errors = _this.state.errors;


            if (errors) {

                return React.createElement(
                    'ul',
                    { style: { border: "1px solid", margin: "10px", padding: "10px" } },
                    errors.map(function (error) {
                        return React.createElement(
                            'li',
                            null,
                            JSON.stringify(error)
                        );
                    })
                );
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    ExampleSchema.prototype.componentDidMount = function componentDidMount() {
        this.setState({
            formData: this.props.formData
        });
    };

    ExampleSchema.prototype.render = function render() {
        var _state = this.state,
            schema = _state.schema,
            uiSchema = _state.uiSchema,
            formData = _state.formData,
            errors = _state.errors;


        return React.createElement(
            'div',
            null,
            React.createElement(Schema, _extends({}, this.props, { formData: formData,
                onChange: this.onChange,
                onSubmit: this.onSubmit,
                onDialog: this.onDialog,
                onUpload: this.onUpload })),
            React.createElement(
                'p',
                null,
                'errors'
            ),
            this.renderErrors(),
            React.createElement(
                'p',
                null,
                'formData:'
            ),
            JSON.stringify(formData),
            React.createElement(
                'p',
                null,
                'schema:'
            ),
            JSON.stringify(schema)
        );
    };

    return ExampleSchema;
}(Component);

export default ExampleSchema;